module.exports = __webpack_public_path__ + "media/images/flags/4x3/com-1d6273480224826da8167949c7c8a437.svg";